// src/lib/opportunity/documentArchetypes.ts
//
// Document archetypes for opportunity generated packages. A "proposal"
// is the revision-priced customer quote; a "contract" is a finalized
// agreement package the user sends for signature (manually or via an
// external e-sign tool) and later re-uploads signed into opp_documents.
// Shared by client + server — keep this file dependency-light.

import type { OpportunityOutputType } from "../../types/opportunity.js";

export const OPPORTUNITY_DOCUMENT_ARCHETYPES = ["proposal", "contract"] as const;
export type OpportunityDocumentArchetype =
  (typeof OPPORTUNITY_DOCUMENT_ARCHETYPES)[number];

export const OPPORTUNITY_DOCUMENT_ARCHETYPE_LABELS: Record<
  OpportunityDocumentArchetype,
  string
> = {
  proposal: "Proposal",
  contract: "Contract",
};

export function isOpportunityDocumentArchetype(
  value: unknown,
): value is OpportunityDocumentArchetype {
  return value === "proposal" || value === "contract";
}

/** Coerce persisted/legacy values; rows predating the archetype column are proposals. */
export function normalizeDocumentArchetype(value: unknown): OpportunityDocumentArchetype {
  return isOpportunityDocumentArchetype(value) ? value : "proposal";
}

/** Package-level generated output type for an archetype. */
export function outputTypeForArchetype(
  archetype: OpportunityDocumentArchetype,
): OpportunityOutputType {
  return archetype === "contract" ? "contract_package" : "proposal_package";
}

/** Inverse of `outputTypeForArchetype` for package rows (split-page outputs count as proposal). */
export function archetypeForOutputType(
  outputType: OpportunityOutputType,
): OpportunityDocumentArchetype {
  return outputType === "contract_package" ? "contract" : "proposal";
}
